import React from 'react';
import './ProcoreCard.css';

const ProcoreCard = ({ children, className = '', title, subtitle, actions, style, ...props }) => {
  return (
    <div className={`procore-card ${className}`} style={style} {...props}>
      {(title || subtitle || actions) && (
        <div className="card-header">
          <div className="card-header-content">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="card-actions">{actions}</div>}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
};

export default ProcoreCard;
